import { UserOutlined } from '@ant-design/icons';
import { Button, Col, Flex, List } from 'antd';
import Text from 'antd/es/typography/Text';
import React, { Component } from 'react';
import { formatChatDate } from '../../../utils';
import { IMessageItem } from '../../user';

interface IChatListProps {
  chatMessageList: IMessageItem[];
  setRecipient: (args: { recipientId: string; recipientName: string }) => void;
  chatMessagesLoadMore: () => void;
}

class _ChatList extends Component<IChatListProps> {
  messageListRef = React.createRef<HTMLDivElement>();

  state = {
    isScrolledToBottom: true,
    isLoadingMessages: false,
    hasMoreMessages: true,
    oldScrollHeight: 0,
  };

  componentDidMount(): void {
    this.scrollToBottom(true);
  }

  componentDidUpdate(prevProps: IChatListProps) {
    const { chatMessageList } = this.props;

    if (chatMessageList.length !== prevProps.chatMessageList.length) {
      const scrollableDiv = this.messageListRef.current;

      if (this.state.isLoadingMessages) {
        const newScrollHeight = scrollableDiv?.scrollHeight || 0;
        if (scrollableDiv) {
          scrollableDiv.scrollTop = newScrollHeight - this.state.oldScrollHeight;
        }
        this.setState({ isLoadingMessages: false });
      } else {
        if (this.state.isScrolledToBottom) {
          this.scrollToBottom(true);
        }
      }
    }
  }

  scrollToBottom = (smooth: boolean) => {
    const scrollableDiv = this.messageListRef.current;
    if (scrollableDiv) {
      scrollableDiv.scrollTo({
        top: scrollableDiv.scrollHeight,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }
  };

  handleScroll = () => {
    const scrollableDiv = this.messageListRef.current;
    if (!scrollableDiv) return;

    const isAtBottom = scrollableDiv.scrollHeight - scrollableDiv.scrollTop === scrollableDiv.clientHeight;
    this.setState({ isScrolledToBottom: isAtBottom });

    if (scrollableDiv.scrollTop === 0 && this.state.hasMoreMessages && !this.state.isLoadingMessages) {
      this.setState({
        oldScrollHeight: scrollableDiv.scrollHeight,
        isLoadingMessages: true,
      });

      this.props.chatMessagesLoadMore();
    }
  };

  render(): React.ReactNode {
    const { chatMessageList, setRecipient } = this.props;
    return (
      <div
        id="scrollableDiv"
        ref={this.messageListRef}
        onScroll={this.handleScroll}
        style={{
          height: 400,
          overflow: 'auto',
          borderRadius: 5,
        }}
      >
        <List
          dataSource={chatMessageList}
          renderItem={item => {
            const { date, time } = formatChatDate(item.createdAt);

            return (
              <List.Item key={item.messageId} style={{ paddingTop: 5 }}>
                <Flex vertical style={{ width: '100%' }}>
                  <Flex justify={'space-between'} style={{ width: '100%' }}>
                    <Flex vertical>
                      <Button
                        type="link"
                        style={{ padding: 0 }}
                        icon={<UserOutlined />}
                        iconPosition={'end'}
                        onClick={() => setRecipient({ recipientId: item.userId, recipientName: item.userName })}
                      >
                        {item.userName}
                      </Button>
                      {item?.recipientId && <Text type={'secondary'}>{`для: ${item.recipientName}`}</Text>}
                    </Flex>
                    <Col>
                      {date && (
                        <Text style={{ paddingTop: 5, fontSize: 11 }} type={'secondary'}>
                          {`${date} `}
                        </Text>
                      )}
                      <Text style={{ paddingTop: 5 }}>{time}</Text>
                    </Col>
                  </Flex>
                  <Text>{item.message}</Text>
                </Flex>
              </List.Item>
            );
          }}
        />
      </div>
    );
  }
}

export const ChatList = _ChatList;
